import { useContext } from 'react';
import { Box, DeleteModal, Flex, ModalContext, Text } from 'dash-ui';

import {
  GetMarketAreasDocument,
  useDeleteMarketAreaMutation,
} from 'gql/generated.graphql';
import { MarketAreaModals } from 'pages/market-areas/MarketAreasPage.constants';
import { useTranslation } from 'react-i18next';

function ConfirmationDeleteMarketAreaModal() {
  const { payload } = useContext(ModalContext);
  const { t } = useTranslation(['common', 'pages']);

  const [deleteMarketArea, { loading }] = useDeleteMarketAreaMutation({
    refetchQueries: [GetMarketAreasDocument],
  });

  async function submitMarketAreaDelete() {
    const { marketAreaId } = payload;
    await deleteMarketArea({ variables: { marketAreaId } });
  }

  return (
    <DeleteModal
      title={t('modalDelete.confirmationTextSecond', { entity: 'Market Area' }) || ''}
      entity="Market Area"
      message={
        <Flex flexDirection="column">
          <Text>{t('modalConfirmDelete.actionUnassing')}<strong>{payload?.marketAreaName}</strong>{t('modalConfirmDelete.propertiesCurrentAssigned', {
            entity: 'Market Area'
          })}</Text>
          <Box my={2} />
          <Text>{t('modalConfirmDelete.ProceedDeletion')}</Text>
        </Flex>
      }
      name={payload?.marketAreaName}
      isLoading={loading}
      modalName={MarketAreaModals.CONFIRMATION_DELETE_MARKET_AREA_MODAL}
      onClick={submitMarketAreaDelete}
    />
  );
}

export default ConfirmationDeleteMarketAreaModal;
